import React from 'react';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import rocketmanTransport from '../../../services/RocketmanTransport';
import { useRocketmanTransport } from '../../rocketman/RocketmanTransportContext';
import Currency from '../../Currency/Currency';
import JackpotOdometer from '../../JackpotOdometer';

export default function JackpotHolder() {

  const rocketmanContext = useRocketmanTransport();
  const jackpotData = rocketmanContext.jackpotData;
  const { width } = useWindowDimensions();

  const withoutDecimals = () => {
    if (width < 400 || (width >= 1024 && width < 1200) || (rocketmanTransport.amountFormat !== "" && !/\./.test(rocketmanTransport.amountFormat)) || rocketmanTransport.currencyNumberOfDigits === 0) {
      return true;
    }
    else return false;
  }

  return (
    <div className="jackpot-cash-holder">
      <JackpotOdometer value={Number(Number(jackpotData.jackpot) * Number(rocketmanTransport.myExchangeRate))} format={withoutDecimals() ? 0 : rocketmanTransport.noOfDecimals} duration={60} />  <Currency className={"jackpot-currency " + (rocketmanTransport.r7css ? "r7css" : "")}>{rocketmanTransport.myCurrency}</Currency>
    </div>
  )
}
